export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/60 border border-primary-200/50 mb-4">
            <i className="ri-mail-send-line text-primary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">合作 · 投稿 · 反馈</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            欢迎触手漫画爱好者与创作者与我们取得联系
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 space-y-6">
            <a href="#faq" className="group flex items-start gap-4 p-4 rounded-lg border border-background-200/60 hover:border-primary-200 bg-background-50 hover:bg-primary-50/30 transition-all cursor-pointer no-underline">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿与合作</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  如有触手漫画投稿、商务合作或广告投放需求，欢迎通过邮件与我们联系。我们期待与更多触手漫画创作者和合作伙伴携手，共同丰富触手漫画的内容生态。
                </p>
              </div>
            </a>

            <a href="#faq" className="group flex items-start gap-4 p-4 rounded-lg border border-background-200/60 hover:border-primary-200 bg-background-50 hover:bg-primary-50/30 transition-all cursor-pointer no-underline">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className="ri-feedback-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见建议</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们非常重视每一位读者的反馈。如果你对触手漫画网有任何优化建议或功能需求，欢迎随时告诉我们，一起打造更好的触手漫画阅读平台。
                </p>
              </div>
            </a>

            <a href="#faq" className="group flex items-start gap-4 p-4 rounded-lg border border-background-200/60 hover:border-primary-200 bg-background-50 hover:bg-primary-50/30 transition-all cursor-pointer no-underline">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0 group-hover:bg-secondary-500 group-hover:text-white transition-colors">
                <i className="ri-shield-user-line text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">版权与投诉</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  触手漫画网尊重知识产权。如有版权相关问题或侵权投诉，请通过邮件联系我们，我们将在第一时间核实处理。
                </p>
              </div>
            </a>
          </div>

          <div className="flex-1 bg-background-100 rounded-lg border border-background-200/60 p-6">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-chat-3-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
              <h3 className="text-base font-semibold text-foreground-900">发送消息</h3>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">你的称呼</label>
                <div className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-400 cursor-not-allowed select-none">
                  请输入昵称
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                <div className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-400 cursor-not-allowed select-none">
                  请输入邮箱
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                <div className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-400 cursor-not-allowed select-none h-24">
                  请输入你想说的话...
                </div>
              </div>
              <a
                href="#faq"
                className="block w-full text-center px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                联系我们（查看常见问答）
              </a>
              <p className="text-xs text-foreground-400 text-center">
                本表单为展示样式，具体联系请参阅上方联系方式
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}